module.exports = {"621223100":"城关镇","621223101":"哈达铺镇","621223102":"理川镇","621223103":"南阳镇","621223104":"官亭镇","621223105":"沙湾镇","621223200":"阿坞乡","621223204":"南河乡","621223205":"八力乡","621223206":"木耳乡","621223207":"庞家乡","621223209":"何家堡乡","621223211":"贾河乡","621223212":"将台乡","621223213":"车拉乡","621223214":"新城子藏族乡","621223215":"临江乡","621223216":"好梯乡","621223217":"韩院乡","621223218":"竹院乡","621223219":"兴化乡","621223220":"甘江头乡","621223223":"新寨乡","621223224":"狮子乡","621223225":"两河口乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621223.json
// module id = 2744
// module chunks = 0